import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import InsuranceListing from "./InsuranceListing/InsuranceListing";
import InsuranceListingRevamp from "./InsuranceListingRevamp/InsuranceListingRevamp";
import InsuranceListingV2 from "./InsuranceListingV2/InsuranceListingV2";
import {
  InsuranceListingWrapperProps,
  ListingPageProps,
  ListingPageV2Props,
  ListingRevampProps,
} from "./types";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { ListingPageV2 } from "@tm/static";

const InsuranceListingWrapper = ({
  listingRevamp = true,
  onLoginRequest,
  ...props
}: InsuranceListingWrapperProps & { onLoginRequest?: () => void }) => {
  const partner = getPartnerOnClientSide();
  const device = useBreakpointV2();

  if (partner === PARTNER.MYPARTNER) {
    if (device === "lg") {
      return <InsuranceListingV2 {...(props as ListingPageV2Props)} />;
    }
    return (
      <ListingPageV2
        payload={(props as ListingPageV2Props).listingData}
      />
    );
  }

  if (listingRevamp) {
    return (
      <InsuranceListingRevamp
        {...(props as ListingRevampProps)}
        onLoginRequest={onLoginRequest}
      />
    );
  }

  return (
    <InsuranceListing listingData={(props as ListingPageProps).listingData} />
  );
};

export default InsuranceListingWrapper;
